// gon.campaign データへの統一アクセスを提供するヘルパー
//
// デフォルトで window.gon を参照するが、コンストラクタに gon プロバイダ関数を渡すことで
// 任意のソースから読むこともできる（テストでの DI 用途）。
//
// コンストラクタで gon を一度だけ評価し、以後はその snapshot を参照する。
// これにより同一インスタンス内では gon の値が安定し、不変ビューとして扱える。

class GonCampaignAccessor {
  constructor(gonProvider = () => (typeof window !== 'undefined' ? window.gon : undefined)) {
    this._gon = gonProvider();
  }

  get campaign() {
    return this._gon?.campaign || {};
  }

  // 基本キャンペーン情報
  get entityId() {
    return this.campaign?.entity_id;
  }

  get name() {
    return this.campaign?.name;
  }

  get status() {
    return this.campaign?.status;
  }

  get startDate() {
    return this.campaign?.start_date;
  }

  get endDate() {
    return this.campaign?.end_date;
  }

  // エクストラ情報
  get isLogin() {
    return this.campaign?.extra?.is_login;
  }

  get entryButtonStatus() {
    return this.campaign?.extra?.entry_button_status;
  }

  // エントリーボタン関連
  // object_with_entry_typeから導出（サーバー側のデータ重複を解消）
  get entryButtonObject() {
    const withEntryType = this.campaign?.entry_buttons?.object_with_entry_type;
    if (!withEntryType) return {};

    return Object.fromEntries(
      Object.entries(withEntryType).map(([id, data]) => [id, data.value])
    );
  }

  get entryButtonObjectWithEntryType() {
    return this.campaign?.entry_buttons?.object_with_entry_type;
  }

  get entryButtonDisplay() {
    return this.campaign?.entry_buttons?.display;
  }

  // モジュールコンテンツ関連
  get moduleContentContent() {
    return this.campaign?.module_content?.content;
  }

  get moduleContentExtendJavascriptPath() {
    return this.campaign?.module_content?.extend_javascript_path;
  }

  get moduleContentExtendStylesheetPath() {
    return this.campaign?.module_content?.extend_stylesheet_path;
  }

  // 完了ページエディタの編集内容（管理画面の完了ページエディタ用）
  get finishPageModuleContentContent() {
    return this.campaign?.finish_page_module_content?.content;
  }

  // 完了ページリンクボタンの表示制御データ（エンドユーザー画面用）
  // 表示判定はサーバー側で完結済み。{ visible, redirect_url } を返す
  get finishLinkButton() {
    return this.campaign?.finish_link_button;
  }

  // プレビュー関連
  get defaultCampaignPeriodMode() {
    return this.campaign?.preview?.default_period_mode;
  }

  // チーム画像
  // team画像はteamに属するが、便宜上本モジュールからも取得可能にしておく
  get teamImages() {
    return this._gon?.team_images || [];
  }

  // デバッグ用
  debugLog() {
    if (process.env.NODE_ENV === 'development') {
      console.log('Campaign Data:', this.campaign);
      console.log('Legacy gon structure:', this._gon);
    }
  }
}

export default GonCampaignAccessor;
